import '@updater-components/icon';
import template from './unsubscribe.html';
import { actions, selectors } from '../../state';
import './unsubscribe.global.css';

class UnsubscribeController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    const { dispatch, getState } = this.updStore;
    const token = selectors.router.currentParamsProp('token', getState());
    dispatch(actions.unsubscribe.create({ invite_token: token }));
  }
}

export const UnsubscribeComponent = {
  template,
  controller: UnsubscribeController,
};
